export const GET_SHOPPING_CART_REQUEST = 'GET_SHOPPING_CART_REQUEST';
export const GET_SHOPPING_CART_SUCCESS = 'GET_SHOPPING_CART_SUCCESS';
export const GET_SHOPPING_CART_FAILURE = 'GET_SHOPPING_CART_FAILURE';

export const SHOPPING_CART_BACK_STEP = 'SHOPPING_CART_BACK_STEP';
export const SHOPPING_CART_NEXT_STEP = 'SHOPPING_CART_NEXT_STEP';
export const SHOPPING_CART_GO_TO_STEP = 'SHOPPING_CART_GO_TO_STEP';

export const SHOPPING_CART_RESET_CART = 'SHOPPING_CART_RESET_CART';
